/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable react/jsx-no-bind */

import {
  Button,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  tableCellClasses,
  Paper,
  Grid,
  Stack,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
  Chip,
  Autocomplete,
  Checkbox,
  DialogContent,
  DialogTitle,
  DialogActions,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import countries from 'i18n-iso-countries';
import { getCountryCallingCode } from 'libphonenumber-js';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import * as Yup from 'yup';
import { Container } from 'reactstrap';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Person, Email, Phone, LocationOn } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PortraitIcon from '@mui/icons-material/Portrait';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import imagepreview from '../../../media/upload.png';
import NoimageFound from '../../../media/noimage.jpg';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import NoResultsFound from '../../../components/NoResultsFound';
import LedgerAdd from '../Common/LedgerAdd';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#4379F2',
  },
  whiteSpace: 'nowrap',
});

const StyledTableCell2 = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#8EB486',
  },
  whiteSpace: 'nowrap',
});

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const resetStates = {
  fullName: '',
  dob: '',
  addr1: '',
  addr2: '',
  addr3: '',
  coo: 'IN',
  branch: '',
  tel: '',
  alterTel: '',
  mailid: '',
  city: '',
  state: '',
  country: '',
  pincode: '',
  requested_date: '',
  salesPerson: '',
  remarks: '',
  idCardType: '',
  IdCardNo: '',
  IDcardFile: null,
  WebAccess: '',
  isActive: true,
  referedby: '',
  referother: '',
  leadstatus: '',

};

const Countrys = {
  'INDIA': 'IN',
  'UNITED KINGDOM': 'UK',
  'SRILANKA': 'SL',
};

const idCardTypes = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'Voters ID Card' },
  { id: 2, name: 'Driving License' },
  { id: 3, name: 'PAN Card' },
  { id: 4, name: 'Ration Card' },
  { id: 5, name: 'Aadhar Card' },
  { id: 6, name: 'Passport' },
  { id: 7, name: 'VISA' },
  { id: 8, name: 'Refugee Card' },
  { id: 9, name: 'NIC' },
  { id: 10, name: 'Residence Permit' },
];

const approvalStatusOptions = [
  { label: 'All', value: 'All' },
  { label: 'Pending', value: 'P' },
  { label: 'Approved', value: 'Y' },
  { label: 'Origin Changed', value: 'T' },
];

const statusOptions = [
  { label: 'All', value: '0' },
  { label: 'Hot', value: 'H' },
  { label: 'Cold', value: 'C' },
  { label: 'Warm', value: 'W' },
];

const LedgerApproval = () => {
  const theme = useTheme();
  const classes = useStyles();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));

  const [phoneFilterSearch, setPhoneFilterSearch] = useState('');
  const [getDataForView, setGetDataForView] = useState([]);
  const [AllData, setAllData] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [initialValue, setInitialValue] = useState(resetStates);
  const [branchList, setBranchList] = useState([]);

  // const [branchListFilter, setBranchListFilter] = useState([]);
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [countryList, setCountryList] = useState([]);
  const [filtersData, setFiltersData] = useState([]);
  const [allCustomerData, setAllCustomerData] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [editID, setEditID] = useState('');
  const [salesPersons, setSalesPersons] = useState([]);
  const [otherBranchBool, setOtherBranchBool] = useState(false);
  const [webAccess, setWebAccess] = useState(false);
  const [oneCustomerFollowUps, setOneCustomerFollowUps] = useState([]);
  const [openFollowUpTable, setOpenFollowUpTable] = useState(null);
  const [ledgerDetails, setLedgerDetails] = useState(null);
  const [transactionBool, setTransactionBool] = useState(false);
  const [customerEmailidData, setCustomerEmailidData] = useState([]);
  const [salesExecutiveFilterData, setSalesExecutiveFilterData] = useState([]);
  const [isDialogOpen, setDialogOpenState] = useState(false);
  const [telCode, setTelCode] = useState('  ');
  const fieldRefs = useRef({});
  const [referedby, setReferedby] = useState([]);
  const [oldData,setOldData] = useState([]);

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList', {
        headers: {
          Country: origin,
        },
      });
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

     const GetReferedby = async (cntry) => {
      try {
        const config = {
        headers: {
          Country: cntry,
        },
      };
        const response = await axios.post('signUp/GetReferedby',{},config);
        setReferedby(response.data);
      } catch (err) {
        console.error(err);
      }
    }

  const GetCountryList1 = async (cntry) => {
    try {
      const res = await axios.post('/signup/GetCountryList', null, {
        headers: {
          Country: cntry,
        },
      });
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const GetSalesExecutives = async (origin) => {
    try {
      const res = await axios.get('/Approval/LoginApprovalRoute/GetAllSalesExecutive', {
        headers: {
          Country: origin,
        },
      });
      setSalesPersons(res.data);
    } catch (err) {
      console.log(err.message);
      setSalesPersons([]);
    }
  };

  const focusOnField = (fieldName) => {
    if (fieldRefs.current[fieldName]) {
      try { fieldRefs.current[fieldName].focus(); } catch (e) { console.warn(e); }
      return;
    }

    let element = null;
    switch (fieldName) {
      case 'country':
      case 'state':
        element = document.querySelector(`[name="${fieldName}"] input`);
        break;
      case 'branch':
      case 'coo':
      case 'idCardType':
      case 'referedby':
        element = document.querySelector(`[name="${fieldName}"]`);
        break;
      case 'salesPerson':
        element = document.querySelector('#salesperson-select input');
        break;
      default:
        element = document.querySelector(`[name="${fieldName}"]`);
        if (!element) {
          const wrapper = document.querySelector(`[data-field="${fieldName}"]`);
          if (wrapper) element = wrapper.querySelector('input, textarea, select');
        }
        break;
    }

    if (element) {
      element.focus();
      if (['branch','coo','idCardType','referedby'].includes(fieldName)) element.click();
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (element.setSelectionRange) {
        const length = element.value?.length || 0;
        setTimeout(() => { element.setSelectionRange(length, length); }, 0);
      }
    }
  };

  const handleValidationFlow = async (values, validateForm, setFieldValue, submitForm) => {
    const errors = await validateForm(values);
    const errorPriority = [
      'fullName', 'dob', 'mailid', 'addr1', 'addr2', 'addr3',
      'coo', 'country', 'state', 'city', 'pincode',
      'tel', 'alterTel', 'branch', 'idCardType', 'IdCardNo',
      'salesPerson', 'remarks', 'referedby', 'referother'
    ];
    const orderedErrors = {};
    errorPriority.forEach((f) => { if (errors[f]) orderedErrors[f] = errors[f]; });
    Object.keys(errors).forEach((f) => { if (!orderedErrors[f]) orderedErrors[f] = errors[f]; });
    if (Object.keys(orderedErrors).length > 0) {
      const firstErrorKey = Object.keys(orderedErrors)[0];
      setTimeout(() => openSnackBar(orderedErrors[firstErrorKey], 'error'), 100);
      focusOnField(firstErrorKey);
      return;
    }
    const shouldExit = await checkInitialCondition(values.mailid);
    if (shouldExit) return;
    submitForm();
  };

  const GetSalesExecutivesForFilter = async () => {
    try {
      const res = await axios.get('/Approval/LoginApprovalRoute/GetAllSalesExecutive', {
        headers: {
          Country: sessionStorage.getItem('country'),
        },
      });
      setSalesExecutiveFilterData(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const getState = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      if (res) {
        setStateList(res.data);
      }
    } catch (err) {
      console.log(err.message);
      setStateList([]);
    }
  };

  const GetCustomerHelp = async () => {
    try {
      const res = await axios.get('/master/customer/GetCustomerHelp/4');
      setFiltersData(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const GetCustomerHelpAll = async () => {
    try {
      const res = await axios.get('Approval/LoginApprovalRoute/GetAllWindowsCustomer');
      console.log(res.data.length,'length')
      setAllCustomerData(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const ValidationSchema = useMemo(
    () =>
      Yup.lazy((values) =>
        Yup.object({
          fullName: Yup.string()
          .required('Name is required')
          .min(3, 'Name is too short'),
          dob: Yup.date()
            .nullable()
            .required('Date of birth is required')
            .test('valid-year', 'Year must be realistic (between 1900 and current year)', function (value) {
              if (!value) return false;
              const year = new Date(value).getFullYear();
              const currentYear = new Date().getFullYear();
              return year >= 1900 && year <= currentYear;
            }),
          addr1: Yup.string().required('Address Line 1 is required'),
          addr2: Yup.string(),
          addr3: Yup.string(),
          city: Yup.string().required('Enter your city'),
          // state: Yup.object().required('Select state'),
          // country: Yup.object().required('Select country'),
          country: Yup.object().when('coo', {
            is: (coo) => coo === sessionStorage.getItem('Origin'), // Condition based on 'coo'
            then: (schema) => schema.required('Select a country'), // Country is required
            // .shape({
            //   CountryId: Yup.number().required('CountryId is required'),
            //   CountryName: Yup.string().required('CountryName is required'),
            // }),
            otherwise: (schema) => schema.notRequired(), // Make it optional if condition is not met
          }),
          pincode: Yup.string()
            .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
            .max(15, 'Pincode cannot exceed 15 characters')
            .required('Pincode is required'),
          alterTel: Yup.string()
            // .required('Alternative Contact number is required')
            .matches(/^\d+$/, 'Alternative Contact number must contain only digits')
            .min(9, 'Alternative Contact number must be at least 9 digits')
            .max(15, 'Alternative Contact number must not exceed 15 digits'),
          tel: Yup.string()
            .required('Contact number is required')
            .matches(/^\d+$/, 'Contact number must contain only digits')
            .min(9, 'Contact number must be at least 9 digits')
            .max(15, 'Contact number must not exceed 15 digits'),
          mailid: Yup.string()
            .email('Invalid email format')
            .max(50, 'Mail ID cannot exceed 50 characters')
            .required('Mail ID is required'),
          coo: Yup.string().required('Country of origin is required'),
          branch: Yup.string().required('Branch is required'),
          // requested_date: Yup.date().nullable().required('Date of birth is required'),
          // salesPerson: Yup.array().min(1, 'Assign Sales Person for this customer').required(),
          salesPerson: Yup.array().when('coo', {
            is: (coo) => coo === sessionStorage.getItem('Origin'),
            then: (schema) => schema.min(1, 'Assign Sales Person for this customer').required(),
            otherwise: (schema) => schema.notRequired(),
          }),
          remarks: Yup.string().max(100, 'Remarks must not exceed 100 characters'),
          // IDcardFile: Yup.mixed().required('Upload ID card file'),
          idCardType: values.IDcardFile ? Yup.string().required('select idCardType') : Yup.string(),
          // IdCardNo: values.IDcardFile ? Yup.string().required('IdCardNo is required') : Yup.string(),
          IdCardNo: values.IDcardFile
            ? Yup.string()
              .required('IdCardNo is required')
              .matches(/^[a-zA-Z0-9 ]*$/, 'No special characters allowed') // Allows letters, numbers, and spaces
            : Yup.string().matches(/^[a-zA-Z0-9 ]*$/, 'No special characters allowed'),
        })
      ),
    [initialValue]
  );

  const getStateList = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      setStateList(res.data);
    } catch (err) {
      console.log(err.message);
      setStateList([]);
    }
  };

  const findTelCode = (countryName) => {
    try {
      const countryCode = countries.getAlpha2Code(countryName, 'en');
      setTelCode(`+${getCountryCallingCode(countryCode)}`);
    } catch {
      setTelCode('  ');
    }
  };

  function getNameById(id) {
    const cardType = idCardTypes.find((item) => item.id === id);
    return cardType ? (cardType.name === 'Select' ? '' : cardType.name) : 'ID not found';
  }

  const getIdCardNameById = (id) => {
    // Find the ID card type based on the provided id
    const idCard = idCardTypes.find((card) => card.id === id);

    // If found, return the name, otherwise return an empty string or any fallback value
    return idCard ? idCard.name : '';
  };

  async function InsertCustomerTimeLine(customerid) {
    const newData = {
      Optype: 'New',
      customerId: customerid,
      companyId: sessionStorage.getItem('CompanyId'),
      branchId: 0,
      Order_ID: 0,
      Order_Type: '',
      remarks: '',
      followup: 'Approved',
      followupDate: new Date(),
      createdBy: sessionStorage.getItem('UserId'),
      createdOn: new Date(),
    };

    try {
      showLoading();
      const response = await axios.post('signup/InsertCustomerTimeline', newData);
      if (response.status === 200) {
        await GetCountryList();
        // openSnackBar('Customer Timeline Created Successfully!', 'success');
      }
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function checkInitialCondition(mailid) {
    try {
      const response = await axios.post('login/verifyEmailId', { EmailId: mailid });

      // Assuming the API returns a boolean or a specific value to indicate whether to proceed
      const data = response.data.filter((a) => a.WebAccess === 'Y');
      setCustomerEmailidData(data);
      if (data && data.length > 0 && Number(editID) !== Number(data[0].CustomerId)) {
        // Show the popup message
        // openSnackBar('A transaction is found, cannot proceed!', 'error');
        handleOpenCustomerDialog();
        return true; // Indicate that the process should stop
      }
      return false; // Indicate that the process can continue
    } catch (error) {
      // openSnackBar(error.response?.data || 'Failed to check initial condition!', 'error');
      return true; // Stop the process in case of an error
    }
  }

  async function UserApproval(values) {
    let modifiedUrl;
    const originalUrl = selectedImageFile;
    const baseUrl = `${axios.baseURL}TCMSWeb/`;
    if (typeof originalUrl !== 'object') {
      modifiedUrl = originalUrl.replace(baseUrl, '');
    } else {
      modifiedUrl = selectedImageFile;
    }

    // Mapping the data to the backend API input names
    const formData = new FormData();
    formData.append('CustomerId', editID);
    formData.append('CUSTOMERNAME', values.fullName || '');
    formData.append('DOB', moment(values.dob).format('YYYY-MM-DD')); // Assuming backend expects date in YYYY-MM-DD format
    formData.append('Phone', String(values.tel || '').trim());
    formData.append('AlternativePhone', String(values.alterTel || '').trim());
    formData.append('EMAILID', values.mailid || '');
    formData.append('ADDRESS1', values.addr1 || '');
    formData.append('ADDRESS2', values.addr2 || '');
    formData.append('ADDRESS3', values.addr3 || '');
    formData.append('COUNTRY', values.country.CountryName || '');
    formData.append('STATE', values.state ? values.state.StateName : '');
    formData.append('CUSSTATEID', values.state ? values.state.StateId : 0);
    formData.append('CUSCOUNTRYID', values.country.CountryId || '');
    formData.append('ZIPCODE', values.pincode || '');
    formData.append('CITY', values.city || '');
    formData.append('Remarks', values.remarks || '');
    formData.append('IdCardtype', values.idCardType || 0);
    formData.append('IdCardNo', values.IdCardNo || '');
    formData.append('IdCardName', getIdCardNameById(values.idCardType) || '');
    formData.append('SignupRequestDate', moment(values.SignupRequestDate).format('YYYY-MM-DD'));
    formData.append('Origin', values.coo);
    formData.append('ApprovedBy', sessionStorage.getItem('UserId'));
    formData.append('CompanyId', sessionStorage.getItem('CompanyId'));
    formData.append('DocImage', modifiedUrl);
    formData.append('salesExecutives', JSON.stringify(values.salesPerson[0]));
    formData.append('Webaccess', values.WebAccess);
    formData.append('BranchID', values.branch);
    formData.append('Active', values.isActive ? 'Y' : 'N');
    formData.append('Referedby', values.referedby || 0);
    formData.append('OtherReferSource', values.referother || '');
    formData.append('ModifyBy', sessionStorage.getItem('UserId'));
    formData.append('LeadStatus', values.leadStatus || '');
    const config = {
      headers: {
        Country: sessionStorage.getItem('Origin'),
        Origined: values.coo,
        'Content-Type': 'multipart/form-data',
      },
    };
    try {
      showLoading();
     const getReferralSourceName = (referralId) => {
    const referral = referedby.find(ref => Number(ref.ReferralSourceId) === Number(referralId));
    return referral ? referral.ReferralSourceName : '';
  };

  // Map oldData to match newData structure
                  const oldDataMapped = {
                    CUSTOMERID: oldData.CUSTOMERID || 0,
                    CUSTOMERNAME: oldData.CUSTOMERNAME || '',
                    DOB: oldData.DOB ? moment(oldData.DOB).format('YYYY-MM-DD') : '',
                    Phone: oldData.PHONE || '',
                    AlternativePhone: oldData.ALTERNATIVEPHONE || '',
                    EMAILID: oldData.EMAILID || '',
                    ADDRESS1: oldData.ADDRESS1 || '',
                    ADDRESS2: oldData.ADDRESS2 || '',
                    ADDRESS3: oldData.ADDRESS3 || '',
                    COUNTRY: oldData.COUNTRY || '',
                    STATE: oldData.STATE || '',
                    ZIPCODE: oldData.ZIPCODE || '',
                    CITY: oldData.CITY || '',
                    Remarks: oldData.remarks || '',
                    IdCardNo: oldData.IDCARDNO || '',
                    IdCardName: oldData.IDCARDTYPE ? getNameById(oldData.IDCARDTYPE) : '',
                    SignupRequestDate: oldData.SignupRequestDate ? moment(oldData.SignupRequestDate).format('YYYY-MM-DD') : '',
                    Origin: oldData.Origin || '',
                    Referedby: getReferralSourceName(oldData.ReferralSourceId),
                    OtherReferSource: oldData.OtherReferSource || '',
                    salesPersonName: oldData.SalesPerson || ''
                  };

                  // Parse newData from formData
                  const {
                    CUSTOMERNAME,
                    DOB,
                    Phone,
                    AlternativePhone,
                    EMAILID,
                    ADDRESS1,
                    ADDRESS2,
                    ADDRESS3,
                    COUNTRY,
                    STATE,
                    ZIPCODE,
                    CITY,
                    Remarks,
                    IdCardNo,
                    IdCardName,
                    SignupRequestDate,
                    Origin,
                    Referedby,
                    OtherReferSource,
                    salesExecutives
                  } = Object.fromEntries(formData.entries());

                  const parsedSalesExecutives = JSON.parse(salesExecutives || {});
                  
                  // Get new referral source name
                  const newReferralName = getReferralSourceName(Referedby);
                  

                  const newData = {
                    CUSTOMERNAME,
                    DOB,
                    Phone,
                    AlternativePhone,
                    EMAILID,
                    ADDRESS1,
                    ADDRESS2,
                    ADDRESS3,
                    COUNTRY,
                    STATE,
                    ZIPCODE,
                    CITY,
                    Remarks,
                    IdCardNo,
                    IdCardName,
                    SignupRequestDate,
                    Origin,
                    Referedby: newReferralName, // Use the name instead of ID
                    OtherReferSource,
                    ...parsedSalesExecutives
                  };
     const response= await axios.post('Approval/LoginApprovalRoute/UpdateLoginApproval', formData, config);

     console.log('response',response.data.action.rowsAffected.length);
     console.log('response sales',response.data.seinsertResult.rowsAffected.length)
   
      if (values.WebAccess === 'P') {
        if (values.coo === sessionStorage.getItem('Origin')) {
          await SendMailOnLedgerApproved(editID);
          await InsertCustomerTimeLine(editID);
          await SendMailForAsssignedSalesPerson(editID);
        }
      }
      else if(response.data.action.rowsAffected.length > 0 
              || response.data.seinsertResult.rowsAffected.length > 0)
        {
           await axios.post('notifications/mails/sendLedgerUpdateMail',
            { Old : oldDataMapped,
              New : newData
            }
          )
        }

      if (salesData.length > 0 && values.salesPerson[0].salesPersonId !== salesData[0].salesPersonId) {
        await SendMailForAsssignedSalesPerson(editID);
      }
      await getAllData();
      await GetCustomerHelp();
      await GetCountryList();
      setOpen(false);
      if (webAccess) {
        openSnackBar('Customer Has Been Updated Successfully !', 'success');
      } else {
        openSnackBar('Customer Has Been Approved Successfully !', 'success');
      }
    } catch (e) {
      // openSnackBar('Something Went Wrong try Again !', 'error');
    }
    setOpen(false);
    hideLoading();
  }

  async function SendMailOnLedgerApproved(editID) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'SendMailOnLedgerApproved',
        customerid: editID,
      });
      if (response.status === 200) {
        openSnackBar('Mail Has Been Sent Successfully!, Please check Your Email', 'success');
      }
    } catch (e) {
      // openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function SendMailForAsssignedSalesPerson(editID) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'SendMailForAsssignedSalesPerson',
        customerid: editID,
      });
      if (response.status === 200) {
        openSnackBar('Mail Has Been Sent Successfully!, Please check Your Email', 'success');
      }
    } catch (e) {
      // openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: 4,
      };
      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      const response = await axios.post('signup/GetBranchList', requestData, config);
      const {data} = response;
      // setBranchList(data.filter((i) => i.webBranch !== 'N' && i.BranchName.trim().toLowerCase() !== 'other'));
      setBranchList(data.filter((i) => i.webBranch !== 'N'));
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function GetBranchListFilter(cntry) {
    try {
      const requestData = {
        CompanyId: 4,
      };
      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      const response = await axios.post('signup/GetBranchList', requestData, config);
      const {data} = response;
      // setBranchList(data.filter((i) => i.webBranch !== 'N' && i.BranchName.trim().toLowerCase() !== 'other'));
      // setBranchListFilter(data.filter((i) => i.webBranch !== 'N' && i.BranchName.trim().toLowerCase() !== 'other'));
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const handleCountryChange = (value) => {
    if (!value) return;
    setStateList([]);
    getStateList(value.CountryId);
    findTelCode(value.CountryName);
  };

  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];

  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Update the selected file and error state based on the fileType
    if (fileType === 'photo') {
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const [approvalStatus, setApprovalStatus] = useState('P'); // Filter for approvalStatus
  const [status, setStatus] = useState('0'); // Filter for status
  const [companyId, setCompanyId] = useState(sessionStorage.getItem('CompanyId'));
  const [searchType, setSearchType] = useState('name'); // Type of search ('name' or 'phone')
  const [searchValue, setSearchValue] = useState(''); // Value for search input
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
  const [salesExecutive, setSalesExecutive] = useState(null);

  // const [branch, setBranch] = useState('');

  async function getAllData() {
    try {
      showLoading();
      const CusID = filtersData.find((card) => card.CUSTOMERNAME.toLowerCase() === searchValue.toLowerCase());
      const customerId = searchType === 'name' && CusID ? CusID.CUSTOMERID : '0';
      const phoneNo = searchType === 'phone' && searchValue ? searchValue : '0';
      const branch = 0;
      const SE = salesExecutive ? salesExecutive?.salesPersonId : 0;
      const response = await axios.get(
        `/Approval/LoginApprovalRoute/GetAllLoginApproval/${customerId}/${phoneNo}/${approvalStatus}/${companyId}/${branch}/${SE}/${status}`
      );
      setAllData(response.data);
      setGetDataForView(response.data);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  const GetLedgerApprovalExcel = async () => {
    showLoading();
    try {
      const CusID = filtersData.find((card) => card.CUSTOMERNAME.toLowerCase() === searchValue.toLowerCase());
      const customerId = searchType === 'name' && CusID ? CusID.CUSTOMERID : '0';
      const customerName = searchType === "name" && CusID ? CusID.CUSTOMERNAME : "0";
      const phoneNo = searchType === 'phone' && searchValue ? searchValue : '0';
      const branch = 0;
      const SE = salesExecutive ? salesExecutive?.salesPersonId : 0;
      const SEname = salesExecutive ? salesExecutive?.salesPersonName : "0";
      const response = await axios.get(
        `/Approval/LoginApprovalRoute/GetLedgerApprovalExcel/${customerId}/${phoneNo}/${approvalStatus}/${companyId}/${branch}/${SE}/${status}/${SEname}/${customerName}/${searchType}`,
        { responseType: 'blob' }
      );

      const excelBlob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      saveAs(excelBlob, `Ledger Followup Panel-${moment(new Date()).format('MMMM Do YYYY, h-mm a')}`);
      setTimeout(() => {
        hideLoading();
      }, 2000);
    } catch (error) {
      if (error.response?.status === 404) {
        openSnackBar('No records found to export.', 'error');
      } else {
        openSnackBar('Something went wrong! Try again.', 'error');
      }
      hideLoading();
    }
  };

  useEffect(() => {
    getAllData();
    GetCountryList();
    GetCustomerHelp();
    GetCustomerHelpAll();
    GetSalesExecutives(sessionStorage.getItem('country'));
    GetSalesExecutivesForFilter();
    GetBranchListFilter(sessionStorage.getItem('country'));
    // GetReferedby(sessionStorage.getItem('country'));
  }, []);

  // pagination
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = getDataForView.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { totalRows, currentPage };
  }, [getDataForView, page, rowsPerPage]);

  const handleReviewClick = async (data) => {
    setOldData(data);
    setEditID(data.CUSTOMERID);
    getState(data.CusCountryId);
    const response = await axios.get(`/Approval/LoginApprovalRoute/GetSalesPerson/${data.CUSTOMERID}`);
    setViewData({ ...data, SALESPERSON: response.data });
    setSalesData(response.data);
    if (sessionStorage.getItem('Origin') === 'IN') {
      if (data.IDCARDNO && data.IDCARDTYPE) {
        setImagePreview(`${axios.defaults.inImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg?v=${Date.now()}`);
        setSelectedImageFile(
          `${axios.defaults.inImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg?v=${Date.now()}`
        );
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    } else if (sessionStorage.getItem('Origin') === 'UK') {
      if (data.IDCARDNO && data.IDCARDTYPE) {
        setImagePreview(`${axios.defaults.ukImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg?v=${Date.now()}`);
        setSelectedImageFile(
          `${axios.defaults.ukImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg?v=${Date.now()}`
        );
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    }else if (sessionStorage.getItem('Origin') === 'SL') {
      if (data.IDCARDNO && data.IDCARDTYPE) {
        setImagePreview(`${axios.defaults.slImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg?v=${Date.now()}`);
        setSelectedImageFile(
          `${axios.defaults.slImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg?v=${Date.now()}`
        );
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    }

    // Fetch state list based on the country ID
    let stateList = [];
    try {
      if (!data.COUNTRYID) return;
      const stateResponse = await axios.get(`/signup/GetAllState/${data.COUNTRYID}`);
      if (stateResponse) {
        stateList = stateResponse.data;
        setStateList(stateList);
      }
    } catch (err) {
      console.log(err.message);
      setStateList([]);
    }

    // Find the state from the stateList based on the StateId
    const selectedState = stateList.find((state) => state.StateId === data.STATEID) || null;

    GetBranchList(data.Origin || 'IN');
    GetReferedby(data.Origin);
    const branchName = data.Branch_Name?.trim()?.toLowerCase() ?? ''; // Empty string as fallback
    if (branchName === 'other' && data.WebAccess !== 'T') {
      openSnackBar('A customer was signed up in the Other branch. kindly change that.');
    }
    setOtherBranchBool(branchName === 'other' && data.WebAccess !== 'T');
    setTransactionBool(data.TransactionFound === 1 && data.WebAccess !== 'T');
    const countryData = countryList.find((country) => data.COUNTRYID === country.CountryId) || ''
    const mappedValues = {
      fullName: data.CUSTOMERNAME || '',
      dob: moment(data.DOB).format('YYYY-MM-DD'),
      addr1: data.ADDRESS1 || '',
      addr2: data.ADDRESS2 || '',
      addr3: data.ADDRESS3 || '',
      coo: data.Origin || 'IN',
      // branch: branchName === 'other' ? '' : data.BRNACHID || '',
      branch: data.BRNACHID || '',
      tel: data.PHONE || '',
      alterTel: data.ALTERNATIVEPHONE || '',
      mailid: data.EMAILID || '',
      city: data.CITY || '',
      state: selectedState,
      country: countryData || '',
      pincode: data.ZIPCODE || '',
      requested_date: moment(data.SignupRequestDate).format('YYYY-MM-DD'),
      salesPerson: response.data || '',
      remarks: data.remarks || '',
      idCardType: data.IDCARDTYPE || '',
      IDcardFile: null,
      IdCardNo: data.IDCARDNO || '',
      WebAccess: data.WebAccess || '',
      isActive: data.ACTIVE === 'Y',
      referedby: data.ReferralSourceId || '',
      referother: data.OtherReferSource || '',
      leadStatus: data.LEADSTATUS || '',
    };
    findTelCode(countryData.CountryName);
    setWebAccess(data.WebAccess === 'Y');
    setInitialValue(mappedValues);
    setOpen(true); // Assuming you're opening a modal for editing
  };
  const fetchAutoCompleteOptions = (value) => {
    if (!value.trim()) {
      setAutoCompleteOptions([]); // Clear options if input is empty
      return;
    }

    const filteredOptions = filtersData.filter(
      (item) =>
        searchType === 'name'
          ? item.CUSTOMERNAME.toLowerCase().includes(value.toLowerCase())
          : item.Phone && item.Phone.includes(value) // Handle empty Phone fields
    );

    const formattedOptions = filteredOptions.map((item) => ({
      label: searchType === 'name' ? item.CUSTOMERNAME : item.Phone || 'No Phone Available',
      value: item.CUSTOMERID,
      details: searchType === 'name' ? item.CUSTOMERNAME : item.Phone,
    }));

    setAutoCompleteOptions(formattedOptions);
  };

  const handleFollowUpTableToggle = (rowIndex, data) => {
    setLedgerDetails(data);
    GetOneCustomerTimeline(data);
    setOpenFollowUpTable(true);
  };

  async function GetOneCustomerTimeline(customerData) {
    try {
      showLoading();
      const response = await axios.get(
        `/Transactions/Customer_Timeline/GetOneCustomerAllTimeline/${customerData.CUSTOMERID}`
      );
      setOneCustomerFollowUps(response.data);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  const [openConfirmDialogDelete, setOpenConfirmDialogDelete] = useState(false);

  const handleOpenConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(true);
  };

  const handleCloseConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(false);
  };

  const [openDialogPreview, setOpenDialogPreview] = useState(false);

  const handleOpenDialogPreview = () => {
    setOpenDialogPreview(true);
  };

  const handleCloseDialogPreview = () => {
    setOpenDialogPreview(false);
  };

  const [openCustomerDialog, setOpenCustomerDialog] = useState(false);

  const handleOpenCustomerDialog = () => {
    setOpenCustomerDialog(true);
  };

  const handleCloseCustomerDialog = () => {
    setOpenCustomerDialog(false);
  };

  const handleReviewButtonClick = () => {
    setDialogOpenState(true);
  };

  const closeDialog = () => {
    setDialogOpenState(false);
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#8EACCD',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Ledger Review & Approval
            </Typography>
          </Typography>
        </Grid>

        <Grid container spacing={2} p={1} my={1} rowSpacing={3} columnSpacing={1}>
          <Grid item md={3} xs={12}>
            {/* Approval Status Filter */}
            <TextField
              fullWidth
              select
              label="Approval Status"
              value={approvalStatus} // Current selected value
              onChange={(e) => setApprovalStatus(e.target.value)} // Update approvalStatus
              variant="outlined"
              size="small"
            >
              {approvalStatusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label} {/* Display the descriptive label */}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item md={3} xs={12}>
            {/* Status Filter */}
            <TextField
              fullWidth
              select
              label="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              variant="outlined"
              size="small"
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item md={6} xs={12}>
            <Autocomplete
              options={salesExecutiveFilterData}
              getOptionLabel={(salesPerson) => salesPerson.salesPersonName}
              renderOption={(props, salesPerson) => (
                <li {...props} key={salesPerson.salesPersonId}>
                  {salesPerson.salesPersonName}
                </li>
              )}
              isOptionEqualToValue={(salesPerson) => salesPerson.salesPersonId === salesExecutive.salesPersonId}
              value={salesExecutive || null}
              name="salesExecutive"
              onChange={(event, value) => {
                setSalesExecutive(value);
              }}
              size="small"
              renderInput={(params) => <TextField {...params} label="Sales Executive" />}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            {/* Search Type Selector */}
            <TextField
              fullWidth
              select
              label="Search By"
              value={searchType}
              onChange={(e) => {
                setSearchType(e.target.value);
                setSearchValue('');
                setAutoCompleteOptions([]);
              }}
              variant="outlined"
              size="small"
            >
              <MenuItem value="name">Customer Name</MenuItem>
              <MenuItem value="phone">Phone Number</MenuItem>
            </TextField>
          </Grid>
          <Grid item md={5} xs={12}>
            {/* Autocomplete for Search Input */}
            <Autocomplete
              // freeSolo
              options={autoCompleteOptions.filter((option) =>
                option.details ? option.details.toLowerCase().startsWith(searchValue.toLowerCase()) : false
              )}
              value={searchValue || null}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.details)} // Ensure it displays details
              onInputChange={(event, value) => {
                setSearchValue(value);
                fetchAutoCompleteOptions(value);
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  setSearchValue(newValue.label);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={`Search by ${searchType === 'name' ? 'Name' : 'Phone'}`}
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </Grid>
          {/* <Grid item md={3} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="branch-label">Branch</InputLabel>
              <Select
                labelId="branch-label"
                value={branch}
                name="branch"
                onChange={(e) => {
                  console.log('Selected Branch ID:', e.target.value);
                  setBranch(e.target.value);
                }}
              >
                <MenuItem key={0} value={0}>
                  All
                </MenuItem>
                {branchListFilter.length > 0 ? (
                  branchListFilter.map((branch) => (
                    <MenuItem key={branch.BranchId} value={branch.BranchId}>
                      {branch.BranchName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No branches available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid> */}

          <Grid item md={1} xs={12}>
            {/* View Button */}
            <Button variant="contained" color="primary" onClick={getAllData} fullWidth>
              View
            </Button>
          </Grid>
          <Grid item md={1} xs={12}>
            <Button
              variant="contained"
              style={{ color: 'white', backgroundColor: '#118a27' }}
              onClick={GetLedgerApprovalExcel}
              fullWidth
            >
              Excel
            </Button>
          </Grid>
          <Grid item md={2} xs={12}>
            {/* Add Ledger Button */}
            <Button variant="contained" color="warning" onClick={handleReviewButtonClick} fullWidth>
              Add Ledger
            </Button>
          </Grid>
        </Grid>
        {getDataForView.length > 0 ? (
          <>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    <StyledTableCell align="left">Ledger Details</StyledTableCell>
                    <StyledTableCell align="center">Requested On</StyledTableCell>
                    <StyledTableCell align="center">Sales Executive</StyledTableCell>
                    <StyledTableCell align="center">Approved By</StyledTableCell>
                    <StyledTableCell align="center">Approved On</StyledTableCell>
                    <StyledTableCell align="center">Approval Status</StyledTableCell>
                    <StyledTableCell align="center">Updated By</StyledTableCell>
                    <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2 }}>
                      Actions
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? getDataForView.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : getDataForView
                  ).map((data, i) => (
                    <TableRow key={data.CUSTOMERID} hover>
                      <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                      <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                        <Stack spacing={1} py={1}>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <PortraitIcon fontSize="x-small" color="primary" />
                            <Typography variant="body2" pr={1}>
                              {data.CUSTOMERNAME || '-'}
                              {data.LEADSTATUS === 'H' ? (
                                <Chip size="small" color="error" label="Hot 🔥" />
                              ) : data.LEADSTATUS === 'W' ? (
                                <Chip label="Warm ☀️" size="small" color="warning" />
                              ) : data.LEADSTATUS === 'C' ? (
                                <Chip label="Cold ❄️" size="small" color="info" />
                              ) : (
                                ''
                              )}
                            </Typography>{' '}
                          </Stack>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <LocationOn fontSize="x-small" color="error" />
                            <Typography variant="body2">
                              {[data.ADDRESS1, data.ADDRESS2, data.ADDRESS3].filter(Boolean).join(', ') || '-'} <br />
                              {[data.CITY, data.STATE, data.ZIPCODE, data.COUNTRY].filter(Boolean).join(', ') || '-'}
                            </Typography>
                          </Stack>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Phone fontSize="x-small" color="success" />
                            <Typography variant="body2" mr={2} pr={1}>
                              {data.PHONE || '-'}
                            </Typography>{' '}
                            | <Email fontSize="x-small" color="error" />
                            <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                              {data.EMAILID || '-'}
                            </Typography>
                            |{' '}
                            <Typography variant="body2" pr={1}>
                              Dob : {data.DOB ? moment(data.DOB).format('DD-MM-YYYY') : '-'}
                            </Typography>
                          </Stack>{' '}
                        </Stack>
                      </TableCell>
                      <TableCell align="center">
                        {data.SignupRequestDate ? moment(data.SignupRequestDate).format('DD-MM-YYYY') : '-'}
                      </TableCell>
                      <TableCell align="center">{data.SalesPerson || '-'}</TableCell>
                      <TableCell align="center">{data.ApprovedBy || '-'}</TableCell>
                      <TableCell align="center">
                        {data.Approvedon && data.Approved !== 'N' 
                        ? moment(data.Approvedon).format('DD-MM-YYYY') : '-'}
                      </TableCell>
                      <TableCell align="center">
                        {data.WebAccess === 'Y' ? (
                          <Chip label="Approved" size="small" color="success" />
                        ) : data.WebAccess === 'T' ? (
                          <Chip label="Origin Changed" size="small" color="error" />
                        ) : (
                          <Chip label="Pending" size="small" color="warning" />
                        )}
                      </TableCell>
                      <TableCell align="center">{data.ModifyByName || '-'}</TableCell>
                      <TableCell align="center" sx={{ position: 'sticky', right: 0, bgcolor: '#F9FAFB', zIndex: 1 }}>
                        <Stack direction="column" spacing={1} justifyContent="center" alignItems="center">
                          <Button
                            variant={data.WebAccess === 'Y' || data.WebAccess === 'T' ? 'outlined' : 'contained'}
                            color={data.WebAccess === 'Y' || data.WebAccess === 'T' ? 'primary' : 'success'}
                            sx={{ boxShadow: 1 }}
                            onClick={() => handleReviewClick(data)}
                            size="small"
                          >
                            {data.WebAccess === 'T' ? 'Preview' : data.WebAccess === 'Y' ? 'Edit' : 'Approve'}
                          </Button>
                          {data.Approved === 'Y' && data.WebAccess === 'Y' && (
                            <Button
                              variant="contained"
                              color="info"
                              sx={{ boxShadow: 1, whiteSpace: 'nowrap' }} // Corrected whiteSpace
                              onClick={() => handleFollowUpTableToggle(i, data)}
                              size="small"
                              fullWidth
                              startIcon={<EventRepeatIcon fontSize="small" />}
                            >
                              Follow-ups
                            </Button>
                          )}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              mt={2}
            />
          </>
        ) : (
          <NoResultsFound />
        )}
        <Grid m={2}>
          <Dialog
            maxWidth={viewData.WebAccess === 'P' ? 'xl' : 'lg'}
            open={open}
            onClose={() => {
              setOpen(!open);

              setInitialValue({ color: '' });
            }}
            fullScreen={viewData.WebAccess === 'P'}
          >
            <Container component={Paper} elevation={2}>
              {otherBranchBool && (
                <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, p: 2 }}>
                  <Chip
                    label="A customer was signed up in the Other branch. kindly change that."
                    size="small"
                    color="warning"
                    variant="contained"
                    icon={<ReportGmailerrorredIcon />}
                    sx={{ mb: 1 }}
                  />
                </Stack>
              )}
              {transactionBool && (
                <Stack sx={{ p: 1 }}>
                  <Chip
                    label={
                      <Typography sx={{ whiteSpace: "normal", wordBreak: "break-word", fontSize: '12px' }}>
                        A transaction is found, can't change the origin.
                      </Typography>
                    }
                    size="small"
                    color="warning"
                    variant="contained"
                    icon={<ReportGmailerrorredIcon />}
                    sx={{ mb: 1, height: "auto" }}
                  />
                </Stack>
              )}
              <Divider sx={{ my: 2 }} variant="middle">
                <Chip
                  label={
                    viewData.WebAccess === 'P'
                      ? viewData.WebAccess === 'Y'
                        ? 'Ledger Review & Save'
                        : 'Ledger Review & Approval'
                      : 'Review Approved Data'
                  }
                  size="small"
                  color={viewData.WebAccess === 'P' ? 'success' : 'primary'}
                />
              </Divider>

              <Stack sx={{ px: 2, pt: 0 }}>
                <Paper>
                  <Formik
                    validationSchema={ValidationSchema}
                    initialValues={initialValue}
                    onSubmit={async (values, { resetForm }) => {
                      const shouldExit = await checkInitialCondition(values.mailid);
                      if (shouldExit) {
                        return;
                      }
                      await UserApproval({ ...initialValue, ...values });
                      resetForm();
                      setTelCode('  ');
                    }}
                  >
                    {({
                      submitForm,
                      touched,
                      values,
                      errors,
                      handleChange,
                      handleBlur,
                      isSubmitting,
                      setFieldTouched,
                      validateForm,
                      setFieldValue,
                    }) => (
                      <Form>
                        {values.WebAccess === 'T' ? (
                          <Grid container spacing={2} p={1} rowSpacing={2} columnSpacing={1}>
                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Full Name
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.CUSTOMERNAME}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Date of Birth
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {moment(viewData.DOB).format('DD-MM-YYYY')}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Requested Date
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {moment(viewData.SignupRequestDate).format('DD-MM-YYYY')}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Address Line 1
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.ADDRESS1}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Address 2
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.ADDRESS2}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Address 3
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.ADDRESS3}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Country
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.COUNTRY}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Province/State
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.STATE}
                                </Typography>
                              </Typography>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                City
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.CITY}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Postal Code
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.ZIPCODE}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Contact No
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.PHONE}
                                </Typography>
                              </Typography>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Alternative Contact No
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.ALTERNATIVEPHONE}
                                </Typography>
                              </Typography>
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Email
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.EMAILID}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Country of Origin
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.Origin === 'IN'
                                    ? 'INDIA'
                                    : viewData.Origin === 'UK'
                                      ? 'United Kingdom'
                                      : ''}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Branch
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.Branch_Name}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Sales Executive
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {/* {viewData.BRNACHID} */}
                                  {viewData.SALESPERSON?.length
                                    ? viewData.SALESPERSON?.map((val) => val.salesPersonName).join(' , ')
                                    : 'No sales person Assigned'}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                ID Card Type
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {getNameById(viewData.IDCARDTYPE)}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                ID Card No
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.IDCARDNO}
                                </Typography>
                              </Typography>
                            </Grid>

                            <Grid item md={3} xs={12}>
                              <Stack direction={'column'} spacing={2}>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                  border={1}
                                  borderRadius={1}
                                  borderColor="#e0e0e0"
                                  p={1}
                                  justifyContent="center"
                                >
                                  <Stack direction="row" alignItems="center" justifyContent={'center'} spacing={1}>
                                    <Box>
                                      <label htmlFor="fileInput">
                                        <img
                                          src={
                                            selectedImageFile ===
                                              `${sessionStorage.getItem('Origin') === 'IN'
                                                ? axios.defaults.inImageURL
                                                : sessionStorage.getItem('Origin') === 'UK'
                                                ? axios.defaults.ukImageURL
                                                : axios.defaults.slImageURL
                                              }`
                                              ? NoimageFound
                                              : selectedImageFile === null ||
                                                selectedImageFile === '' ||
                                                !selectedImageFile
                                                ? imagepreview
                                                : imagePreview
                                          }
                                          alt="imgfor"
                                          className={classes.chooseFileButton}
                                          style={{
                                            maxWidth: '200px',
                                            minWidth: '200px',
                                            maxHeight: '92px',
                                            minHeight: '92px',
                                            objectFit: 'contain',
                                          }}
                                        />
                                        {/* <input
                                          className={classes.fileInput}
                                          id="fileInput"
                                          type="file"
                                          accept="image/jpeg"
                                          name="IDcardFile"
                                          // onChange={(event) => {
                                          //   handleFileChange(event, 'photo');
                                          // }}
                                          style={{ display: 'none' }}
                                        /> */}
                                      </label>
                                    </Box>
                                  </Stack>
                                </Stack>
                              </Stack>
                            </Grid>
                            <Grid item md={10} xs={12}>
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Remarks
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.remarks}
                                </Typography>
                              </Typography>
                            </Grid>
                             <Grid item md={3} xs={12}>
                             <Typography variant="subtitle2" color="GrayText" pr={1}>
                                Referred By
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.ReferralSourceName || ''}
                                </Typography>
                              </Typography>
                          </Grid>
                           <Grid item md={3} xs={12}> 
                              <Typography variant="subtitle2" color="GrayText" pr={1}>
                               Other Referral Source
                                <br />{' '}
                                <Typography variant="h6" color="#009688">
                                  {viewData.OtherReferSource || ''}
                                </Typography>
                              </Typography>
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                            <Grid item xs={12}>
                              <Stack justifyContent={'end'} alignItems={'end'}>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        size='small'
                                        color='success'
                                        checked={values.isActive}
                                        mt={2}
                                        onChange={(event) =>
                                          setFieldValue("isActive", event.target.checked) // Update Formik state
                                        }
                                      />} label="Active" />
                                </FormGroup>
                              </Stack>
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Name"
                                type="text"
                                name="fullName"
                                onBlur={handleBlur}
                                error={touched.fullName && !!errors.fullName}
                                helperText={touched.fullName && errors.fullName ? errors.fullName : ''}
                                value={values.fullName}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Date Of Birth"
                                type="date"
                                name="dob"
                                inputProps={{ max: '9999-12-31' }}
                                InputLabelProps={{ shrink: true }}
                                onBlur={handleBlur}
                                error={touched.dob && !!errors.dob}
                                helperText={touched.dob && errors.dob ? errors.dob : ''}
                                value={values.dob}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Requested Date"
                                type="date"
                                name="requested_date"
                                disabled
                                inputProps={{ max: '9999-12-31' }}
                                InputLabelProps={{ shrink: true }}
                                onBlur={handleBlur}
                                error={touched.requested_date && !!errors.requested_date}
                                helperText={
                                  touched.requested_date && errors.requested_date ? errors.requested_date : ''
                                }
                                value={values.requested_date}
                                onChange={handleChange}
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                label="Address Line 1"
                                name="addr1"
                                onBlur={handleBlur}
                                error={touched.addr1 && !!errors.addr1}
                                helperText={touched.addr1 && errors.addr1 ? errors.addr1 : ''}
                                value={values.addr1}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                label="Address Line 2"
                                name="addr2"
                                onBlur={handleBlur}
                                error={touched.addr2 && !!errors.addr2}
                                helperText={touched.addr2 && errors.addr2 ? errors.addr2 : ''}
                                value={values.addr2}
                                onChange={handleChange}
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                label="Address Line 3"
                                name="addr3"
                                onBlur={handleBlur}
                                error={touched.addr3 && !!errors.addr3}
                                helperText={touched.addr3 && errors.addr3 ? errors.addr3 : ''}
                                value={values.addr3}
                                onChange={handleChange}
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <FormControl fullWidth size="small" fullwidth required>
                                <InputLabel id="Country-select-label">Country of Origin</InputLabel>
                                <Select
                                  fullWidth
                                  labelId="Country-select-label"
                                  value={values.coo}
                                  size="small"
                                  name="coo"
                                  label="Country of Origin"
                                  disabled={transactionBool}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue('salesPerson', []);
                                    // GetCountryList1(e.target.value);
                                    setFieldValue('country', '');
                                    setFieldValue('state', '');
                                    setFieldValue('branch', '');
                                    GetBranchList(e.target.value);
                                    // Also refresh referral sources when origin changes
                                     GetReferedby(e.target.value);
                                    // GetSalesExecutives(e.target.value);
                                  }}
                                  error={touched.coo && !!errors.coo}
                                >
                                  {Object.entries(Countrys).map(([fullName, code]) => (
                                    <MenuItem key={code} value={code}>
                                      {fullName} {/* Display the full name */}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {touched.coo && errors.coo && (
                                  <Grid item xs={12}>
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="0 0 0 14px"
                                    >
                                      {errors.coo}
                                    </Typography>
                                  </Grid>
                                )}
                              </FormControl>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <Autocomplete
                                options={values.coo === sessionStorage.getItem('Origin') ? countryList : []}
                                getOptionLabel={(country) => country.CountryName}
                                renderOption={(props, country) => (
                                  <li {...props} key={country.Countryid}>
                                    {country.CountryName}
                                  </li>
                                )}
                                isOptionEqualToValue={(country) => country.CountryId === values.country.CountryId}
                                value={values.country || null}
                                name="country"
                                onChange={(event, value) => {
                                  handleCountryChange(value);
                                  setFieldValue('country', value);
                                  setFieldValue('state', null);
                                }}
                                size="small"
                                onBlur={() => {
                                  setFieldTouched('country', true);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Residing Country"
                                    error={touched.country && !!errors.country}
                                    helperText={touched.country && errors.country}
                                    required
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <Autocomplete
                                options={values.coo === sessionStorage.getItem('Origin') ? stateList : []}
                                getOptionLabel={(state) => state.StateName}
                                renderOption={(props, state) => (
                                  <li {...props} key={state.Stateid}>
                                    {state.StateName}
                                  </li>
                                )}
                                isOptionEqualToValue={(state) => state.StateId === values.state.StateId}
                                value={values.state || null}
                                name="state"
                                onChange={(event, value) => {
                                  setFieldValue('state', value);
                                }}
                                size="small"
                                onBlur={() => {
                                  setFieldTouched('state', true);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Province/State"
                                    error={touched.state && !!errors.state}
                                    helperText={touched.state && errors.state}
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="City"
                                type="text"
                                name="city"
                                onBlur={handleBlur}
                                error={touched.city && !!errors.city}
                                helperText={touched.city && errors.city ? errors.city : ''}
                                value={values.city}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Postal Code"
                                type="text"
                                name="pincode"
                                onBlur={handleBlur}
                                error={touched.pincode && !!errors.pincode}
                                helperText={touched.pincode && errors.pincode ? errors.pincode : ''}
                                value={values.pincode}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              {/* <TextField
                                fullWidth
                                size="small"
                                label="Contact No"
                                type="text"
                                name="tel"
                                onBlur={handleBlur}
                                error={touched.tel && !!errors.tel}
                                helperText={touched.tel && errors.tel ? errors.tel : ''}
                                value={values.tel}
                                // onChange={handleChange}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange({ target: { name: 'tel', value: numericValue } }); // Manually trigger Formik's handleChange
                                }}
                                required
                              /> */}
                              <FormControl fullWidth size="small" required>
                                <InputLabel htmlFor="outlined-adornment-tel">Contact No</InputLabel>
                                <OutlinedInput
                                  id="outlined-adornment-tel"
                                  type="text"
                                  name="tel"
                                  value={values.tel}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange({ target: { name: 'tel', value: numericValue } }); // Manually trigger Formik's handleChange
                                  }}
                                  // onChange={handleChange}
                                  onBlur={handleBlur}
                                  label="Contact No"
                                  error={touched.tel && !!errors.tel}
                                  required
                                  startAdornment={
                                    <InputAdornment position="start">
                                      {telCode}
                                    </InputAdornment>
                                  } // Optional prefix
                                />
                                {touched.tel && errors.tel && (
                                  <Typography variant="caption" color="error">
                                    {errors.tel}
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              {/* <TextField
                                fullWidth
                                size="small"
                                label="Alternative Contact No"
                                type="number"
                                name="alterTel"
                                onBlur={handleBlur}
                                error={touched.alterTel && !!errors.alterTel}
                                helperText={touched.alterTel && errors.alterTel ? errors.alterTel : ''}
                                value={values.alterTel}
                                // onChange={handleChange}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange({ target: { name: 'alterTel', value: numericValue } }); // Manually trigger Formik's handleChange
                                }}
                              /> */}
                              <FormControl fullWidth size="small" required>
                                <InputLabel htmlFor="outlined-adornment-tel">Alternative  No</InputLabel>
                                <OutlinedInput
                                  id="outlined-adornment-tel"
                                  type="text"
                                  name="alterTel"
                                  value={values.alterTel}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange({ target: { name: 'alterTel', value: numericValue } }); // Manually trigger Formik's handleChange
                                  }}
                                  // onChange={handleChange}
                                  onBlur={handleBlur}
                                  label="Alternative  No"
                                  error={touched.alterTel && !!errors.alterTel}
                                  required
                                  startAdornment={
                                    <InputAdornment position="start">
                                      {telCode}
                                    </InputAdornment>
                                  } // Optional prefix
                                />
                                {touched.alterTel && errors.alterTel && (
                                  <Typography variant="caption" color="error">
                                    {errors.alterTel}
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Email"
                                type="email"
                                name="mailid"
                                onBlur={handleBlur}
                                error={touched.mailid && !!errors.mailid}
                                helperText={touched.mailid && errors.mailid ? errors.mailid : ''}
                                value={values.mailid}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <FormControl fullWidth size="small" required>
                                <InputLabel>Branch</InputLabel>
                                {/* <Select
                                  value={values.branch || ''}
                                  name="branch"
                                  size="small"
                                  label="Branch"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.branch && !!errors.branch}
                                >
                                  {branchList.length > 0 ? (
                                    branchList.map((branch) => (
                                      <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                        {branch.BranchName}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem disabled>No branches available</MenuItem>
                                  )}
                                </Select> */}
                                <Select
                                  value={values.branch || ''}
                                  name="branch"
                                  size="small"
                                  label="Branch"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.branch && !!errors.branch}
                                >
                                  {branchList.length > 0 ? (
                                    values.coo === sessionStorage.getItem('Origin') ? (
                                      // Show all branches if the condition is true
                                      branchList.map((branch) => (
                                        <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                          {branch.BranchName}
                                        </MenuItem>
                                      ))
                                    ) : (
                                      // Show only the "Other" branch if the condition is false
                                      branchList
                                        .filter((branch) => branch.BranchName.toLowerCase() === 'other') // Case-insensitive comparison
                                        .map((branch) => (
                                          <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                            {branch.BranchName}
                                          </MenuItem>
                                        ))
                                    )
                                  ) : (
                                    // Handle empty branchList
                                    <MenuItem disabled>No branches available</MenuItem>
                                  )}
                                </Select>

                                {touched.branch && errors.branch && (
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    className="shake-helper-text"
                                    margin="4px 0 0 14px"
                                  >
                                    {errors.branch}
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <Autocomplete
                                // multiple
                                id="salesperson-select"
                                options={salesPersons.filter(
                                  (option) =>
                                    !values.salesPerson?.some(
                                      (selected) => selected.salesPersonId === option.salesPersonId
                                    )
                                )}
                                getOptionLabel={(option) => option.salesPersonName || ''}
                                disableCloseOnSelect
                                value={values.salesPerson?.[0] || null}
                                onBlur={handleBlur}
                                onChange={(event, newValue) => {
                                  setFieldValue('salesPerson', newValue ? [newValue] : []);
                                }}
                                renderOption={(props, option) => <li {...props}>{option.salesPersonName}</li>}
                                // renderTags={(value, getTagProps) =>
                                //   value.map((option, index) => (
                                //     <Chip
                                //       key={index}
                                //       label={option.salesPersonName}
                                //       {...getTagProps({ index })}
                                //       size="small" // Control the size of the chip
                                //       color="primary"
                                //       variant="outlined"
                                //     />
                                //   ))
                                // }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    label="Sales Persons"
                                    error={!!errors.salesPerson && touched.salesPerson}
                                    required
                                  />
                                )}
                                style={{ width: '100%' }}
                                disabled={values.coo !== sessionStorage.getItem('Origin')}
                              />
                              {touched.salesPerson && errors.salesPerson && (
                                <Typography variant="caption" color="error" margin="4px 0 0 14px">
                                  {errors.salesPerson}
                                </Typography>
                              )}
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <FormControl fullWidth size="small">
                                <InputLabel>ID Card Type</InputLabel>
                                <Select
                                  value={values.idCardType || ''}
                                  name="idCardType"
                                  size="small"
                                  label="ID Card Type"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.idCardType && !!errors.idCardType}
                                >
                                  {idCardTypes.length > 0 ? (
                                    idCardTypes.map((idCard) => (
                                      <MenuItem key={idCard.id} value={idCard.id}>
                                        {idCard.name}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem disabled>No ID card types available</MenuItem>
                                  )}
                                </Select>
                                {touched.idCardType && errors.idCardType && (
                                  <Typography variant="caption" color="error" margin="4px 0 0 14px">
                                    {errors.idCardType}
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="ID Card No"
                                type="text"
                                name="IdCardNo"
                                onBlur={handleBlur}
                                error={touched.IdCardNo && !!errors.IdCardNo}
                                helperText={touched.IdCardNo && errors.IdCardNo ? errors.IdCardNo : ''}
                                value={values.IdCardNo}
                                onChange={handleChange}
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <Stack direction={'column'} spacing={2}>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                  border={1}
                                  borderRadius={1}
                                  borderColor="#e0e0e0"
                                  p={1}
                                  justifyContent="center"
                                >
                                  <Stack direction="row" alignItems="center" justifyContent={'center'} spacing={1}>
                                    <Box>
                                      <label htmlFor="fileInput">
                                        <img
                                          src={
                                            selectedImageFile ===
                                              `${sessionStorage.getItem('Origin') === 'IN'
                                                ? axios.defaults.inImageURL
                                               : sessionStorage.getItem('Origin') === 'UK'
                                                ? axios.defaults.ukImageURL
                                                : axios.defaults.slImageURL
                                              }`
                                              ? NoimageFound
                                              : selectedImageFile === null ||
                                                selectedImageFile === '' ||
                                                !selectedImageFile
                                                ? imagepreview
                                                : imagePreview
                                          }
                                          alt="imgfor"
                                          className={classes.chooseFileButton}
                                          style={{
                                            maxWidth: '200px',
                                            minWidth: '200px',
                                            maxHeight: '92px',
                                            minHeight: '92px',
                                            objectFit: 'contain',
                                          }}
                                        />
                                        <input
                                          className={classes.fileInput}
                                          id="fileInput"
                                          type="file"
                                          accept="image/jpeg"
                                          name="IDcardFile"
                                          onChange={(event) => {
                                            handleFileChange(event, 'photo');
                                            handleChange(event);
                                          }}
                                          style={{ display: 'none' }}
                                        />
                                        {(selectedImageFile || !NoimageFound) && (
                                          <Button
                                            onClick={handleOpenDialogPreview}
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            fullWidth
                                            sx={{ boxShadow: 1 }}
                                            mt={1}
                                          >
                                            Preview
                                          </Button>
                                        )}
                                      </label>
                                    </Box>
                                  </Stack>
                                </Stack>
                              </Stack>
                            </Grid>
                            <Grid item md={9} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Remarks"
                                type="text"
                                multiline
                                rows={5}
                                name="remarks"
                                onBlur={handleBlur}
                                error={touched.remarks && !!errors.remarks}
                                helperText={touched.remarks && errors.remarks ? errors.remarks : ''}
                                value={values.remarks}
                                onChange={handleChange}
                              />
                            </Grid>

                             <Grid item md={3} xs={12}>
                            <FormControl fullWidth size="small" >
                              <InputLabel>Referred By </InputLabel>
                              <Select
                                value={values.referedby || ''}
                                name="referedby"
                                size="small"
                                label="Referred By"
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue('referother', '');
                                }}
                                onBlur={handleBlur}
                                error={touched.referedby && !!errors.referedby}
                              >
                                {referedby.length > 0 ? (
                                  referedby.map((refer) => (
                                    <MenuItem key={refer.ReferralSourceId} value={refer.ReferralSourceId}>
                                      {refer.ReferralSourceName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>Not available</MenuItem>
                                )}
                              </Select>
                              
                            </FormControl>
                          </Grid>
                           <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Other Referral Source"
                                type="text"
                                name="referother"
                                inputProps={{ maxLength: 50 }}
                                onBlur={handleBlur}
                                disabled={!referedby.some(ref => ref.ReferralSourceId === values.referedby && ref.ReferralSourceName?.toLowerCase().includes('other'))}
                                error={touched.referother && !!errors.referother}
                                helperText={touched.referother && errors.referother ? errors.referother : ''}
                                value={values.referother || ''}
                                onChange={handleChange}
                              />
                            </Grid>
                          </Grid>
                        )}
                        <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                          <Button
                            onClick={() => {
                              GetCountryList();
                              setOpen(!open);
                              setEditID('');
                              setViewData({});
                              setImagePreview('');
                              setSelectedImageFile('');
                              setInitialValue({ ...resetStates });
                            }}
                            variant="contained"
                            color={values.WebAccess === 'P' ? 'warning' : 'warning'}
                            size="small"
                            sx={{ boxShadow: 1 , mb:1}}
                          >
                            {values.WebAccess === 'P' || values.WebAccess === 'Y' ? 'Cancel' : 'Close'}
                          </Button>
                          {(values.WebAccess === 'P' || values.WebAccess === 'Y') && (
                            <Button
                              onClick={() => handleValidationFlow(values, validateForm, setFieldValue, submitForm)}
                              disabled={isSubmitting}
                              variant="contained"
                              color="primary"
                              size="success"
                              sx={{ boxShadow: 1 ,mb:1}}
                            >
                              {values.WebAccess === 'Y' ? 'Update' : 'Approve'}
                            </Button>
                          )}
                        </Stack>

                        <Dialog open={openDialogPreview} onClose={handleCloseDialogPreview} maxWidth="md">
                          <DialogTitle>Image Preview</DialogTitle>
                          <DialogContent>
                            <img
                              src={
                                selectedImageFile ===
                                  `${sessionStorage.getItem('Origin') === 'IN'
                                    ? axios.defaults.inImageURL
                                   : sessionStorage.getItem('Origin') === 'UK'
                                                ? axios.defaults.ukImageURL
                                                : axios.defaults.slImageURL
                                  }`
                                  ? NoimageFound
                                  : selectedImageFile === null || selectedImageFile === '' || !selectedImageFile
                                    ? imagepreview
                                    : imagePreview
                              }
                              alt="Preview"
                              style={{
                                maxWidth: '100%',
                                maxHeight: '400px',
                                objectFit: 'contain',
                              }}
                            />
                          </DialogContent>
                          <DialogActions>
                            <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
                              <Button
                                onClick={handleOpenConfirmDialogDelete}
                                color="error"
                                variant="outlined"
                                size="small"
                              >
                                Delete
                              </Button>
                              <Button
                                onClick={handleCloseDialogPreview}
                                color="primary"
                                startIcon={<CloseIcon />}
                                variant="contained"
                                size="small"
                              >
                                Close
                              </Button>
                            </Stack>
                          </DialogActions>
                        </Dialog>
                        <Dialog open={openConfirmDialogDelete} onClose={handleCloseConfirmDialogDelete}>
                          <DialogTitle>Confirm Deletion</DialogTitle>
                          <DialogContent>
                            <Typography>Are you sure you want to delete this image?</Typography>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleCloseConfirmDialogDelete} color="primary">
                              Cancel
                            </Button>
                            <Button
                              onClick={() => {
                                setSelectedImageFile(null);
                                setOpenDialogPreview(false);
                                setFieldValue('IdCardNo', '');
                                handleCloseDialogPreview();
                                handleCloseConfirmDialogDelete();
                              }}
                              color="error"
                            >
                              Delete
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Form>
                    )}
                  </Formik>
                </Paper>
              </Stack>
            </Container>
          </Dialog>
        </Grid>

        {/* Dialog for follow-up table */}
        <Dialog open={openFollowUpTable} maxWidth={'xl'} fullScreen={smallScreens} fullWidth>
          <DialogContent>
            <Divider sx={{ mt: 2 }}>
              <Chip
                label={`Follow-ups for ${ledgerDetails?.CUSTOMERNAME}`}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Divider>
            <Grid container spacing={2} mb={1}>
              {!smallScreens && (
                <Grid item md={9} xs={12}>
                  <Stack spacing={1}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <PortraitIcon fontSize="x-small" color="primary" />
                      <Typography variant="subtitle2" color="#243642" pr={1}>
                        {ledgerDetails?.CUSTOMERNAME || '-'}{' '}
                        {ledgerDetails?.LEADSTATUS === 'H' ? (
                          <Chip size="small" color="error" label="Hot 🔥" />
                        ) : ledgerDetails?.LEADSTATUS === 'W' ? (
                          <Chip label="Warm ☀️" size="small" color="warning" />
                        ) : ledgerDetails?.LEADSTATUS === 'C' ? (
                          <Chip label="Cold ❄️" size="small" color="info" />
                        ) : (
                          <Chip label="-" size="small" />
                        )}
                      </Typography>{' '}
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <LocationOn fontSize="x-small" color="error" />
                      <Typography variant="body2">
                        {[
                          ledgerDetails?.ADDRESS1,
                          ledgerDetails?.ADDRESS2,
                          ledgerDetails?.ADDRESS3,
                          ledgerDetails?.CITY,
                          ledgerDetails?.STATE,
                          ledgerDetails?.ZIPCODE,
                          ledgerDetails?.COUNTRY,
                        ]
                          .filter(Boolean)
                          .join(', ') || '-'}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Phone fontSize="x-small" color="success" />
                      <Typography variant="body2" mr={2} pr={1}>
                        {ledgerDetails?.PHONE || '-'}
                      </Typography>{' '}
                      | <Email fontSize="x-small" color="error" />
                      <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                        {ledgerDetails?.EMAILID || '-'}
                      </Typography>
                      |{' '}
                      <Typography variant="body2" pr={1}>
                        Dob : {ledgerDetails?.DOB ? moment(ledgerDetails?.DOB).format('DD-MM-YYYY') : '-'}
                      </Typography>
                    </Stack>{' '}
                  </Stack>
                </Grid>
              )}
            </Grid>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell2 align="center">S.No</StyledTableCell2>
                    <StyledTableCell2 align="center">Follow-up Date & Time </StyledTableCell2>
                    <StyledTableCell2 align="left">Remarks</StyledTableCell2>
                    <StyledTableCell2 align="center">Created Date & Time </StyledTableCell2>
                    <StyledTableCell2 align="center">Created By</StyledTableCell2>
                    {/* <StyledTableCell2 align="center">Actions</StyledTableCell2> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {oneCustomerFollowUps.map((followUp, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {moment.utc(followUp.followupDate).format('LLL')}
                      </TableCell>
                      <TableCell align="left">{followUp.remarks}</TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {moment(followUp.createdOn).format('LLL')}
                      </TableCell>
                      <TableCell align="center">{followUp.CreatedUser}</TableCell>
                      {/* <TableCell align="center" sx={{ padding: '0' }}>
                        <IconButton aria-label="Edit" onClick={() => handleEditFollowUp(followUp)}>
                          <EditIcon color="primary" />
                        </IconButton>
                        <IconButton aria-label="Delete" onClick={() => handleOpenConfirmDialogDelete(followUp.timelineId)}>
                          <DeleteForeverIcon color="error" />
                        </IconButton>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mt={2}>
              <Button
                onClick={() => {
                  setOpenFollowUpTable(null);
                  setOneCustomerFollowUps([]);
                }}
                color="warning"
                variant="contained"
                size="small"
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>
        {/* Confirmation Dialog for Deletion */}

        <Dialog open={openCustomerDialog} onClose={handleCloseCustomerDialog} maxWidth="md">
          <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ErrorOutlineIcon color="error" /> This Email Id already exist.
          </DialogTitle>
          <DialogContent>
            {/* Table to display CustomerName, EmailId, and Status */}
            <Table size="small" aria-label="Customer Details">
              <TableHead>
                <TableRow>
                  <TableCell>Customer Name</TableCell>
                  <TableCell>Email ID</TableCell>
                  <TableCell>Approval Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customerEmailidData.map((customer, index) => (
                  <TableRow key={index}>
                    <TableCell>{customer?.CustomerName}</TableCell>
                    <TableCell>{customer?.EmailId}</TableCell>
                    <TableCell>{customer?.Status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mt={2}>
              <Button
                onClick={handleCloseCustomerDialog}
                color="warning"
                startIcon={<CloseIcon />}
                variant="outlined"
                size="small"
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>

        {/* Add Ledger Popup */}
        <Dialog fullwidth maxWidth={'xl'} open={isDialogOpen} onClose={closeDialog}>
          <DialogTitle>
            <Typography
              variant="h5"
              p={1}
              boxShadow={1}
              borderColor="#11235A"
              textAlign={'center'}
              borderRadius={8}
              color="white"
              sx={{
                background: 'linear-gradient(to right, #4ecdc4, #556270)',
                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
              }}
            >
              <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                Add Ledger
              </Typography>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <LedgerAdd
              setDialogOpenState={setDialogOpenState}
              getAllData={getAllData}
              countryList={countryList}
              salesPersons={salesPersons}
              allCustomerData={allCustomerData}
              GetCustomerHelpAll={GetCustomerHelpAll}
            />
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default LedgerApproval;
